export const categories:string[] = ['전체','가','나','다']
